import { Project } from "../project";

/**
 * Season_Entity type guard.
 *
 * @param {any} seasonJson Season object from API
 * @returns {boolean} Return true if type is Season_Entity
 */
function validator(seasonJson: unknown): seasonJson is Season_Entity {
  if (typeof seasonJson === "object" && seasonJson != null) {
    Season_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(seasonJson).includes(element))
        throw new Error("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class Season_Entity {
  static requiredFields = [
    "id",
    "memberID",
    "name",
    "description",
    "coverURL",
    "color",
    "sourceID",
    "sourceRecordID",
    "missionID",
    "createdAt",
    "updatedAt",
  ];

  constructor(seasonJson: unknown) {
    if (validator(seasonJson)) {
      this.id = seasonJson.id;
      this.memberID = seasonJson.memberID;
      this.name = seasonJson.name;
      this.description = seasonJson.description;
      this.coverURL = seasonJson.coverURL;
      this.color = seasonJson.color;
      this.sourceID = seasonJson.sourceID;
      this.sourceRecordID = seasonJson.sourceRecordID;
      this.missionID = seasonJson.missionID;
      this.projects = seasonJson.projects;
      this.createdAt = seasonJson.createdAt;
      this.updatedAt = seasonJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Season_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  memberID: number;
  name: string;
  description: string;
  projects?: Project[];
  coverURL: string;
  color: string;
  sourceID: number;
  sourceRecordID: number;
  missionID: number;
  createdAt: string;
  updatedAt: string;
}
